import React from "react";

const OtpBox = React.forwardRef(
  (
    props: React.HTMLProps<HTMLInputElement>,
    ref: React.ForwardedRef<HTMLInputElement>
  ) => {
    const {
      onChange = () => {
        return;
      },
      style = {},
      type = "text",
      value = "",
      className,
      ...other
    } = props;
    return (
      <input
        className={`otpBox ${className}`}
        onChange={onChange}
        ref={ref}
        type={type}
        value={value}
        style={style}
        {...other}
      />
    );
  }
);
OtpBox.displayName = "OtpBox";
export default OtpBox;
